import PropTypes from 'prop-types';

import css from './label.module.scss';

const Label = ({ labelText, dataTestId, isRequired }) => (
  <div className={css.labelContainer}>
    <label className={css.label} data-testid={dataTestId}>
      {isRequired ? `${labelText} *` : labelText}
    </label>
  </div>
);

Label.propTypes = {
  labelText: PropTypes.string.isRequired,
  dataTestId: PropTypes.string.isRequired,
  isRequired: PropTypes.bool,
};

export default Label;
